export default __webpack_public_path__ + "static/media/email.48f0db80.svg";